import React from 'react';
import { FormattedMessage } from 'react-intl';
import randomstring from 'uuid/v4';

import BarChartIcon from '@material-ui/icons/BarChart';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import HistoryChartIcon from '@material-ui/icons/List';
import Error from '@material-ui/icons/Error';


import BarChart from './types/BarChart';
import BubbleChart from './types/BubbleChart';
import HistoryChart from './types/HistoricChart';

// eslint-disable-next-line
import style from './_styles.css';



class Currentab extends React.Component {


    handleDownload = (widget) => (event) => {

        this.setState({ loading: true });
        const periodo = widget.metadatos && widget.metadatos.periodo ? widget.metadatos.periodo : '';
        const aditional = periodo ? `?periodo=${periodo} `: '';
        const url = `${process.env.REACT_APP_API_INDICATORS}/${widget.origen}/pdfdetalle${aditional}`;
        const all = periodo ? periodo : 'all';

        const request = new Request(url,
            {
                method: 'GET',
                headers: {
                    Authorization: sessionStorage.token,
                },
            },
        );
        fetch(request).then((response) => {
            response.blob().then((blob) => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = `${widget.nombre}.${widget.origen}.${all}.pdf`;
                a.click();
                this.setState({ loading: false });
            });
        });
    };

    render() {
        const { tab } = this.props;
        const { widgets } = tab;
        const render = widgets.map((w, i) => {w.id = i; return w; });
        const IconButton = ({icon, text}) => {
            return (<div className="box bg_bluish c_white margin_top_12 padding_borders">
                        <div className="flex_auto_row barlow_regular_small margin_top_12 center">
                            {icon}
                        </div>
                        <div className="flex_auto_row barlow_regular_small margin_top_12">
                            <FormattedMessage id={text} />
                        </div>
                    </div>);
        }


        const Widget = ({widget, index}) => {
            const {dashboard_charts} = this.props;
            if(dashboard_charts && dashboard_charts[index]){
                return (
                    <div className="flex_full_row heightWidget padding_4">
                        {!dashboard_charts[index].error &&
                            <div id={index} className="boxBorder heightWidget flex_full_column bg_white  ">
                                {widget.tipo === 1 &&
                                    <BubbleChart 
                                        {...this.props} 
                                        intl={this.props.intl} 
                                        widget={dashboard_charts[index]} 
                                        data={widget}
                                        onDownload={this.handleDownload}
                                        period={widget.metadatos.periodo}
                                        />
                                }
                                {widget.tipo === 2 &&
                                    <BarChart 
                                        {...this.props} 
                                        intl={this.props.intl}
                                        widget={dashboard_charts[index]} 
                                        data={widget}
                                        onDownload={this.handleDownload}
                                        period={widget.metadatos.periodo}
                                        />
                                }
                                {widget.tipo === 3 &&
                                    <HistoryChart 
                                        {...this.props} 
                                        intl={this.props.intl} 
                                        widget={dashboard_charts[index]} 
                                        data={widget}
                                        onDownload={this.handleDownload}
                                        period={widget.metadatos.periodo}
                                        />
                                }
                            </div>
                        }
                        {dashboard_charts[index].error &&
                            <div id={index} className="boxBorder heightWidget flex_full_column bg_white  ">
                                <div className="flex_full_column  padding_12">
                                    <div className="flex_auto_row width100">
                                        <span className="flex_full_row center barlowcondensed_medium c_lipstick uppercase">
                                            {widget.nombre}
                                        </span>
                                    </div>
                                    <div className="flex_full_column margin_top_4 historic center">
                                        <div className="flex_auto_row width100 center">
                                            <Error className="c_lipstick" />
                                            <span className="barlowcondensed_medium c_slate uppercase">
                                                {dashboard_charts[index].error}
                                            </span>
                                        </div>
                                    </div>            
                                </div>
                                
                            </div>
                        }
                    </div>
                )
            } else
                return (
                    <div className="flex_full_row heightWidget padding_4">
                        <div id={index} className="boxBorder heightWidget flex_full_column bg_white  ">
                            <div 
                                className="flex_full_column center hand" 
                                onClick={() => this.props.onAdd(widget)}>
                                <span className="flex_auto_row barlowcondensed_medium c_cornflower_blue uppercase">
                                    {widget.nombre}
                                </span>
                                {widget.tipo === 1 &&
                                    <IconButton 
                                        icon={<BubbleChartIcon className="hand" />}
                                        text={'widget_type_chart_bubble'}
                                        />
                                }
                                {widget.tipo === 2 &&
                                    <IconButton 
                                        icon={<BarChartIcon className="hand" />}
                                        text={'widget_type_chart_bar'}
                                        />
                                }
                                {widget.tipo === 3 &&
                                    <IconButton 
                                        icon={<HistoryChartIcon className="hand" />}
                                        text={'widget_type_chart_historic'}
                                        />
                                }
                            </div>
                        </div>
                    </div>
                );
        }
        return (
                <div className="cards height100 width100">
                    {render && render.length > 0 &&
                        render.map((item, index) => {
                            return (<div key={randomstring()}  className={'bloc card'}>
                                        <Widget widget={item} index={index} />
                                    </div>);
                                })
                    }
                    
                </div>
            );
    }
}


export default Currentab;


// WEBPACK FOOTER //
// ./src/components/complex/dashboard/Currenttab.js